"use strict";
exports.__esModule = true;
var React = require("react");
var react_1 = require("react");
var SituationSelector_1 = require("./PresentSearch/SituationSelector");
var SituationHolder_1 = require("./PresentSearch/SituationHolder");
var SituationSelectModal_1 = require("./PresentSearch/SituationSelectModal");
// 例の値は JS のロード前の表示用に present_search.twig でも直接書かれていることに注意
exports.UnselectedPresentee = {
    name: "例：彼氏、女友達",
    id: ""
};
exports.UnselectedAge = {
    name: "例：20代、30代、40代",
    id: ""
};
exports.UnselectedOccasion = {
    name: "例：誕生日、クリスマス、結婚祝い",
    id: ""
};
exports.PresentSearch = function () {
    // モーダルの状態
    var _a = react_1.useState(SituationSelectModal_1.ModalState.Closed), modalState = _a[0], setModalState = _a[1];
    // モーダルを開く前の選択状態
    var _b = react_1.useState({
        presentee: exports.UnselectedPresentee,
        age: exports.UnselectedAge,
        occasion: exports.UnselectedOccasion
    }), prevSelected = _b[0], setPrevSelected = _b[1];
    // 各選択肢の選択状態
    var _c = react_1.useState(exports.UnselectedPresentee), selectedPresentee = _c[0], setSelectedPresentee = _c[1];
    var _d = react_1.useState(exports.UnselectedAge), selectedAge = _d[0], setSelectedAge = _d[1];
    var _e = react_1.useState(exports.UnselectedOccasion), selectedOccasion = _e[0], setSelectedOccasion = _e[1];
    react_1.useEffect(function () {
        // history に選択状態が保存されていれば一度だけ復元する
        if (window.history.state != null && window.history.state.selected != null) {
            var _a = window.history.state.selected, presentee = _a.presentee, age = _a.age, occasion = _a.occasion;
            if (presentee !== null) {
                setSelectedPresentee(presentee);
            }
            if (age !== null) {
                setSelectedAge(age);
            }
            if (occasion !== null) {
                setSelectedOccasion(occasion);
            }
        }
    }, []);
    react_1.useEffect(function () {
        // モーダルが閉じられたら現在の選択状態を保存しておく
        if (modalState === SituationSelectModal_1.ModalState.Closed) {
            setPrevSelected({
                presentee: selectedPresentee,
                age: selectedAge,
                occasion: selectedOccasion
            });
        }
    }, [modalState]);
    // 各選択肢モーダルを開く
    var openPresenteeModal = function () {
        setModalState(SituationSelectModal_1.ModalState.Presentee);
    };
    var openOccasionModal = function () {
        setModalState(SituationSelectModal_1.ModalState.Occasion);
    };
    // 各選択状態を解除する
    var clearSelectedPresentee = function () {
        setSelectedPresentee(exports.UnselectedPresentee);
        setSelectedAge(exports.UnselectedAge);
        setPrevSelected({
            presentee: exports.UnselectedPresentee,
            age: exports.UnselectedAge,
            occasion: selectedOccasion
        });
    };
    var clearSelectedOccasion = function () {
        setSelectedOccasion(exports.UnselectedOccasion);
        setPrevSelected({
            presentee: selectedPresentee,
            age: selectedAge,
            occasion: exports.UnselectedOccasion
        });
    };
    // 保持している前の選択状態に戻す
    var undoSelected = function () {
        setSelectedPresentee(prevSelected.presentee);
        setSelectedAge(prevSelected.age);
        setSelectedOccasion(prevSelected.occasion);
    };
    var replaceSelectedState = function () {
        // 画面遷移時に選択状態を history に保存しておく
        window.history.replaceState({
            selected: {
                presentee: selectedPresentee,
                age: selectedAge,
                occasion: selectedOccasion
            }
        }, "");
        return true;
    };
    return (React.createElement("form", { className: "present-search__form-container", action: "/present_search" },
        React.createElement(SituationSelector_1.SituationSelector, { name: "presentee", label: "\u8D08\u308B\u76F8\u624B\u306F\uFF1F", selected: selectedPresentee, subSelected: selectedAge, onClickSelector: openPresenteeModal, onClickClear: clearSelectedPresentee }),
        React.createElement(SituationHolder_1.SituationHolder, { name: "age", selected: selectedAge }),
        React.createElement(SituationSelector_1.SituationSelector, { name: "occasion", label: "\u76EE\u7684\u306F\uFF1F", selected: selectedOccasion, onClickSelector: openOccasionModal, onClickClear: clearSelectedOccasion }),
        React.createElement("div", { className: "present-search__form-row" },
            React.createElement("input", { type: "submit", onClick: replaceSelectedState, className: "btn present-search__btn present-search__btn-primary", value: "\u3053\u306E\u6761\u4EF6\u3067\u30AE\u30D5\u30C8\u3092\u63A2\u3059" })),
        React.createElement(SituationSelectModal_1.SituationSelectModal, { state: modalState, setModalState: setModalState, selectedPresentee: selectedPresentee, selectedAge: selectedAge, selectedOccasion: selectedOccasion, selectPresentee: setSelectedPresentee, selectAge: setSelectedAge, selectOccasion: setSelectedOccasion, undoSelected: undoSelected })));
};
